import * as React from "react"
import { NavLink } from "react-router-dom"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import LogoAkbank from "@smpu-web/globalmodules/logo"
import "./style.scss"

const Header = () => {

  return (
    <Block type="header" className="bapp-header">
      <Block className="bapp-header-wrapper">
        <Element className="bapp-header-logo">
          <NavLink to="/" className="bapp-link">
            <LogoAkbank />
          </NavLink>
        </Element>
      </Block>
    </Block>
  )
}

export default Header
